import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback } from 'react';
import { AnalyticsListener, useAnalyticsEvents } from '@atlaskit/analytics-next';
import { ATLASKIT_CHANNEL } from './common/constants';

/**
 * Lets your treat analytics-next events as a Event API events.
 * Also see {@link createAtlaskitToEventChannelRepackager} if you just want to repackage "atlaskit" channel events.
 */
export var createAnalyticsNextToEventChannelRepackager = function createAnalyticsNextToEventChannelRepackager(useEventDispatch, channel) {
  var RepackageAnalyticsNextEvent = function RepackageAnalyticsNextEvent(_ref) {
    var children = _ref.children,
        uiProperties = _objectWithoutProperties(_ref, ["children"]);

    var dispatchAnalytics = useEventDispatch();
    var repackageAtlaskitEvent = useCallback(function (event) {
      dispatchAnalytics(_objectSpread(_objectSpread(_objectSpread({}, uiProperties), event.payload), {}, {
        attributes: _objectSpread(_objectSpread({}, uiProperties.attributes), event.payload.attributes)
      }));
    }, [dispatchAnalytics, uiProperties]);
    return /*#__PURE__*/React.createElement(AnalyticsListener, {
      channel: channel,
      onEvent: repackageAtlaskitEvent
    }, children);
  };

  return RepackageAnalyticsNextEvent;
};
/**
 * Lets your treat atlaskit events as a event channel created from {@link createBaseAnalyticsChannel}.
 * The atlaskit channel gets its own special helper method because it's such a common usecase.
 */

export var createAtlaskitToEventChannelRepackager = function createAtlaskitToEventChannelRepackager(useEventDispatch) {
  var RepackageAtlaskitEvent = createAnalyticsNextToEventChannelRepackager(useEventDispatch, 'atlaskit');
  return RepackageAtlaskitEvent;
};

/**
 * Returns an object that listens to events and fires them as an Atlaskit event on a
 * specified channel
 */
export var createEventChannelToAnalyticsNextRepackager = function createEventChannelToAnalyticsNextRepackager(Listener) {
  var channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ATLASKIT_CHANNEL;
  return function (_ref2) {
    var children = _ref2.children;

    var _useAnalyticsEvents = useAnalyticsEvents(),
        createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;

    var fireAsAtlaskitEvent = useCallback(function (payload) {
      createAnalyticsEvent(payload).fire(channel);
    }, [createAnalyticsEvent]);
    return /*#__PURE__*/React.createElement(Listener, {
      onEvent: fireAsAtlaskitEvent
    }, children);
  };
};